"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = void 0;
const tslib_1 = require("tslib");
const utils_1 = tslib_1.__importDefault(require("./utils"));
class Base {
    constructor(baseURL, clientID) {
        this._baseURL = baseURL;
        this._clientID = clientID;
    }
    /**
     * @deprecated This method is deprecated, please refer to the documentation on how to allow temporary authentication
     * */
    pushAuthentication(username, callback, options = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const initPayload = {
                client_id: this._clientID,
                username,
                options,
            };
            let response = yield utils_1.default.http.post(this._baseURL, "/push_authentication/init", initPayload);
            const { code, devices, notification, expire_at } = response;
            callback(code, devices, notification, expire_at);
            const completePayload = Object.assign(Object.assign({}, initPayload), { options: Object.assign(Object.assign({}, options), { remote_session: { code } }) });
            return yield utils_1.default.http.post(this._baseURL, "/push_authentication/complete", completePayload);
        });
    }
    /**
     * @deprecated This method is deprecated, please refer to the documentation on how to add credentials
     * */
    addAuthenticator(username, callback, options = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let initPayload = {
                client_id: this._clientID,
                username,
                options,
            };
            let initResponse = yield utils_1.default.http.post(this._baseURL, "/add_authenticator/init", initPayload);
            const { code, devices, notification, expire_at } = initResponse;
            callback(code, devices, notification, expire_at);
            const completePayload = Object.assign(Object.assign({}, initPayload), { options: Object.assign(Object.assign({}, options), { remote_session: { code } }) });
            const completeResponse = yield utils_1.default.http.post(this._baseURL, "/add_authenticator/complete", completePayload);
            const initAddPayload = Object.assign(Object.assign({}, initPayload), { options: {
                    remote_session: { session_id: completeResponse.registration_session }
                } });
            const registerInitResponse = yield utils_1.default.http.post(this._baseURL, "/add_authenticator/init", initAddPayload);
            const { uid, session_id: sId } = registerInitResponse, publicKey = tslib_1.__rest(registerInitResponse, ["uid", "session_id"]);
            localStorage.setItem("register_session_id", sId);
            const { challenge } = publicKey;
            publicKey.challenge = utils_1.default.encoding.base64ToBuffer(publicKey.challenge);
            publicKey.user.id = utils_1.default.encoding.base64ToBuffer(publicKey.user.id);
            const credential = yield utils_1.default.navigator.createCredential({ publicKey });
            const response = credential.response;
            const completeAddPayload = Object.assign(Object.assign({}, initAddPayload), { payload: {
                    challenge,
                    id: utils_1.default.encoding.bufferToBase64(credential.rawId),
                    raw_id: utils_1.default.encoding.bufferToBase64(credential.rawId),
                    credential_id: uid,
                    client_data: utils_1.default.encoding.bufferToBase64(response.clientDataJSON),
                    attestation_data: utils_1.default.encoding.bufferToBase64(response.attestationObject),
                } });
            return yield utils_1.default.http.post(this._baseURL, "/add_authenticator/complete", completeAddPayload);
        });
    }
}
exports.Base = Base;
exports.default = Base;
//# sourceMappingURL=base.js.map